import { render } from "./NcrmWorkflowDetail.vue?vue&type=template&id=13c03115&scoped=true"
import script from "./NcrmWorkflowDetail.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowDetail.vue?vue&type=script&lang=js"

import "./NcrmWorkflowDetail.css?vue&type=style&index=0&id=13c03115&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c03115"]])

export default __exports__